import styled from 'styled-components';
export const CSSCommentsBlocWidgetWrapper = styled.div`
    border-radius: ${(props) => props.theme.space.sm}px;
    border: 1px solid ${(props) => props.theme.color.grey1};
    background-color: ${(props) => props.theme.color.white};
    overflow: hidden;
`;
